/**
 *
 *  ? url pada submenu menggunakana naming routes,
 *  ? jadi tidak perlu dibuat format url lengkap
 */
export default [
  {
    icon: "ListIcon",
    menu: "Jadwal Mengajar",
    url: "korprodi-jadwal-mengajar",
    group: "Akademik",
  },
  {
    icon: "ShuffleIcon",
    menu: "Konversi",
    url: "korprodi-konversi",
    group: "Akademik",
  },
  {
    icon: "BookIcon",
    menu: "KRS & Perwalian",
    url: "korprodi-krs-perwalian",
    group: "Akademik",
  },
  {
    icon: "ListIcon",
    menu: "Kurikulum",
    url: "korprodi-kurikulum",
    group: "Akademik",
  },
  {
    icon: "UsersIcon",
    menu: "Mahasiswa",
    url: "korprodi-mahasiswa",
    group: "Mahasiswa",
  },
  {
    icon: "ListIcon",
    menu: "Mata Kuliah",
    url: "korprodi-mata-kuliah",
    group: "Akademik",
  },
  {
    icon: "UserIcon",
    menu: "Plot Dosen Wali",
    url: "plot-dosen-wali",
    group: "Penugasan Dosen",
  },
  {
    icon: "UsersIcon",
    menu: "Plot Kelas",
    url: "plot-kelas",
    group: "Penugasan Dosen",
  },
  {
    icon: "PieChartIcon",
    menu: "Rekap Perkuliahan",
    url: "korprodi-rekap-perkuliahan",
    group: "Monitoring & Laporan",
  },
  // {
  //   icon: "ListIcon",
  //   menu: "Tugas Akhir",
  //   url: "korprodi-tugas-akhir",
  // },
  {
    icon: "ListIcon",
    menu: "Turnitin Mahasiswa",
    url: "korprodi-turnitin",
    group: "Monitoring & Laporan",
  },
  {
    icon: "ListIcon",
    menu: "Nilai Mahasiswa",
    url: "korprodi-nilai",
    group: "Monitoring & Laporan",
  },
  {
    icon: "ListIcon",
    menu: "Publikasi Dosen",
    url: "korprodi-publikasi-dosen",
    group: "Monitoring & Laporan",
  },
  {
    icon: "ListIcon",
    menu: "Aktivitas Mahasiswa",
    url: "korprodi-aktivitas-mahasiswa",
    group: "Monitoring & Laporan",
  },
  {
    icon: "ListIcon",
    menu: "Daftar KRS TA",
    url: "korprodi-krs-ta-sp",
    group: "Monitoring & Laporan",
  },
];
